module.exports = __webpack_public_path__ + "media/pricing/box-61bd4737.png";